import type { MetadataResponse } from '@/api/useMetadata/types'
import type dayjs from 'dayjs'

export type SupplyOptionFilterOptions = {
  terminals: string[]
  suppliers: string[]
  price_types: string[]
  as_of: dayjs.ConfigType
  alternate_products: string[]
  load_numbers: string[]
  contracts: string[]
}

export type SupplyOwnerMap = {
  definitions: SupplyOwnerDefinition[]
}

export type SupplyOwnerDefinition = {
  location_name: string
  product: string
  supply_owner_id: string
}

export type SupplyFilterFlags = {
  only_in_network: boolean
  use_alternates: boolean
  single_supplier_per_load: boolean
  exclude_outages: boolean
}

export const DEFAULT_SUPPLY_FILTER_STATE: SupplyOptionFilterOptions = {
  terminals: [],
  suppliers: [],
  price_types: [],
  as_of: '',
  alternate_products: [],
  load_numbers: [],
  contracts: [],
}

export const DEFAULT_FLAG_STATE: SupplyFilterFlags = {
  only_in_network: false,
  use_alternates: false,
  single_supplier_per_load: false,
  exclude_outages: true,
}

export type DestinationProductCombination = {
  locationName: string
  product: string
  tankIds: string[]
}
